import { TemplateObject } from "../Models/TemplateObject";

export const calculateListItem = (formElementData: any, id:any, value:any, formData:any,removeKey?:any) => {
    let calculatedTotalVal:any = '';
    let percentage:any = '';
    let withoutDiscountTotalVal:any = 0;
    if(!!formData[`meta-data-${id}`] && !!formData[`meta-data-${id}`].calculationId && removeKey === undefined){
        let calculateId = formData[`meta-data-${id}`].calculationId.split("|")
        let subTotalId = formData[`meta-data-${id}`].subTotal
        let finalVal = 1
        calculateId.map((itemId: any) => {
            if(itemId === id){
                finalVal *= value
            }else{
                finalVal *= formData[`${itemId}`]
            }
        })
        formElementData[`${subTotalId}`] = finalVal === 0 ? "" : finalVal
        calculatedTotalVal = calculateTotal(subTotalId.split('-')[0],formElementData,formData)
        formElementData[`subtotal${subTotalId.split('-')[0]}`] = calculatedTotalVal
    }
    if(!!removeKey){
        calculatedTotalVal = value
        formElementData[`subtotal${id.split('-')[0]}`] = calculatedTotalVal
    }
    if (!!formData[`meta-data-${id}`] && !!formData[`meta-data-${id}`].percentageId) {
        let percentageId = formData[`meta-data-${id}`].percentageId.split("|")
        percentage = calculatePercentage(percentageId,value,formData)
        formElementData[`per${id}`] = percentage
    }
    if (!!formData[`meta-data-${id}`] && !!formData[`meta-data-${id}`].withoutDiscountTotal) {
            let withoutDiscountTotal = formData[`meta-data-${id}`].withoutDiscountTotal.split("|")
            let calculatedId =  !!formData[`meta-data-${id}`].calculationId ? formData[`meta-data-${id}`].subTotal.split("-")[0] : ""
            let percentId =  !!formData[`meta-data-${id}`].percentageId ? `per${id}` : ""
            withoutDiscountTotal.map((itemId: any) => {
                if(!!formData[`meta-data-${id}`].calculationId){
                   if(`subtotal${calculatedId}`.toLowerCase() === itemId.toLowerCase()){
                    withoutDiscountTotalVal += Number(calculatedTotalVal)
                   }
                   else{
                        if (formData[`${itemId}`] !== undefined) {
                            withoutDiscountTotalVal += Number(formData[`${itemId}`])
                        }
                   }
                }
                else{
                    if (formData[`${itemId}`] !== undefined) {
                        if(itemId === id){
                            withoutDiscountTotalVal += Number(value)
                        }
                        else if(itemId === percentId){
                            withoutDiscountTotalVal += Number(percentage)
                        }
                        else{
                            withoutDiscountTotalVal += Number(formData[`${itemId}`])
                        }
                    }
                }
            })
            formElementData[`withoutDiscountTotal${formData[`meta-data-${id}`].subTotal.split("-")[0]}`] = withoutDiscountTotalVal
            formElementData[formData[`meta-data-${id}`].totalSum] = withoutDiscountTotalVal
    }
    if (!!formData[`meta-data-${id}`] && !!formData[`meta-data-${id}`].discount) {
        if(`${id}`.toLowerCase() === formData[`meta-data-${id}`].discount.toLowerCase()){
            let discountedVal = formData[`withoutDiscountTotal`+formData[`meta-data-${id}`].subTotal] - percentage
            formElementData[formData[`meta-data-${id}`].totalSum] = discountedVal.toFixed(2)
        }
        else{
            let discountId = formData[`meta-data-${id}`].discount
            if(!!formData[discountId]){
               let percentAmount = (withoutDiscountTotalVal * Number(formData[discountId])) / 100;
                formElementData[`per${discountId}`] = percentAmount
                let discountedVal = withoutDiscountTotalVal - percentAmount
                formElementData[formData[`meta-data-${id}`].totalSum] = discountedVal.toFixed(2)
            }
        }
    }
  };
  const calculateTotal = (formKey: string, formElementData :any,formData:any) => {
    const tempFormData: TemplateObject = { ...formData }
    const metaKeyName = `meta-data-${formKey}`
    if (tempFormData[metaKeyName] !== undefined &&
        tempFormData[metaKeyName].addMoreElement === true &&
        tempFormData[metaKeyName].separator !== null
    ) {
        const id = tempFormData[metaKeyName].separatorId
        const values = []
        if (!tempFormData[metaKeyName].isGroupAdd) {
            const inputFields = Object.keys(formData).filter(key => {
                const re = new RegExp(`^${id}\\d$`, 'g')
                return key.match(re)
            })
            inputFields.forEach(inputId => {
                if (tempFormData[inputId]) {
                    values.push(tempFormData[inputId])
                }
            })
        }
        const groupInputFormate = tempFormData[metaKeyName].groupInputFormate
        const calculateTotalItem = tempFormData[metaKeyName].subTotal
        const modifiedData =formElementData
        let firstGrpValues: any = []
        let calculateTotalItemValue: any = 0
        if (tempFormData[metaKeyName].isGroupAdd === true) {
            const dynamicIndex = tempFormData[metaKeyName].dynamicIndex
            const children = tempFormData[metaKeyName].children
            if (dynamicIndex) {
                dynamicIndex.forEach((inputIndex: number) => {
                    const valueMap: string[] = []
                    let childrensCls: any = []
                    children.forEach((inputId: string) => {
                        childrensCls.push(`${inputId}-${inputIndex}`)
                        if (tempFormData[`${inputId}-${inputIndex}`]) {
                            valueMap.push(tempFormData[`${inputId}-${inputIndex}`])
                        }
                    })
                    if (valueMap.length > 0) {
                        if (groupInputFormate === 'table') {
                            childrensCls.forEach((inputId: string, index: number) => {
                                let val = !!tempFormData[`${inputId}`] ? tempFormData[`${inputId}`] : ""
                                if(calculateTotalItem != "" && inputId.includes(calculateTotalItem)){
                                    if(modifiedData[inputId] !== undefined){
                                        calculateTotalItemValue += Number(modifiedData[inputId])
                                    }else{
                                        calculateTotalItemValue += Number(val)
                                    }
                                }
                            })
                        }
                    }
                })
            }
        }
        if (tempFormData[id]) {
            values.unshift(tempFormData[id])
        }
        else if(modifiedData[id] !== undefined){
            values.unshift(tempFormData[id])
        }
        if (groupInputFormate === 'table' && values.length > 0) {
            const frstchildren = tempFormData[metaKeyName].children
            frstchildren.forEach((inputId: string) => {
                firstGrpValues.push(!!tempFormData[`${inputId}`] ? tempFormData[`${inputId}`] : "")
            })
            tempFormData[metaKeyName].children.forEach((inputId: string, index: number) => {
                if(calculateTotalItem != "" && inputId.includes(calculateTotalItem)){
                    if(modifiedData[inputId] !== undefined){
                        calculateTotalItemValue += Number(modifiedData[inputId])
                    }else{
                        calculateTotalItemValue += Number(firstGrpValues[index])
                    }
                }
            })
        }
        return calculateTotalItemValue
    }
}
const calculatePercentage = (percentageId: any, value: any, formData :any) => {
    let finalVal = 0;
    percentageId.map((itemId: any) => {
        if (formData[`${itemId}`] !== undefined) {
            finalVal += Number(formData[`${itemId}`])
        }
    })
    let precentVal = (finalVal * value) / 100;
    return precentVal.toFixed(2)
}